import { render, staticRenderFns } from "./Avicolas.vue?vue&type=template&id=5ed3b40a"
import script from "./Avicolas.vue?vue&type=script&lang=js"
export * from "./Avicolas.vue?vue&type=script&lang=js"
import style0 from "./Avicolas.vue?vue&type=style&index=0&id=5ed3b40a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports